<template>
    <div class="container-fluid min-content-height">
        <div class="content-header text-center">
            <h2>Account Information</h2>
        </div>
        <div class="card card-body">
            <p class="lead"><strong>Username:</strong> {{this.userData.user}}</p>
            <hr>
            <p class="lead"><strong>Name:</strong> {{this.userData.name}}</p>
            <hr>
            <p class="lead"><strong>Email:</strong> {{this.userData.email}}</p>
            <hr>
            <p class="lead"><button class="float-end btn btn-lg btn-light" @click="$emit('openModal', {view: 'EditAddress', dt: userData.uid})">Edit</button><strong>Address:</strong><br>
            <br>
            <span style="font-size: 22px">{{this.userData.address}}<br>
            {{this.userData.addresstwo}}<br>
            <br>
            {{this.userData.city}}, {{this.userData.state}} {{this.userData.zipcode}}</span>
            </p>
        </div>
        <div class="card card-body">
            <h3 class="text-center"><strong>Subscription</strong></h3>
            <hr>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6 text-center lead"><p class="text-center"><strong>Subscription Service:</strong></p>
                        <span v-if="this.userSubscription.subscription == 'year'">Annual Access</span>
                        <span v-else-if="this.userSubscription.subscription == 'premium'">Premium Annual Access</span>
                        <span v-else-if="this.userSubscription.subscription == 'single'">Single License</span>
                        <span v-else-if="this.userSubscription.subscription == 'free'">Free/Tester License</span>
                        <span v-else>Not currently subscribed</span>
                    </div>
                    <div class="col-3"><p class="text-center"><strong v-if="this.userSubscription.subscription != 'single' || this.userSubscription.subscription != 'free'">Started</strong><strong v-else>Purchased</strong></p><p class="text-center">{{formatDate(this.userSubscription.current_start)}}</p></div>
                    <div class="col-3" v-if="this.userSubscription.subscription != 'single' || this.userSubscription.subscription != 'free'"><p class="text-center"><strong>Expires</strong></p><p class="text-center">{{formatDate(this.userSubscription.current_expire)}}</p></div>
                </div>
                <div class="row">
                    <div class="col">
                        <hr>
                        <p class="lead">Current Status: <em>{{this.userStatus}}</em></p>
                        <!-- not sure what I was going to add here -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'account',
  props: {
    userData: [],
    userStatus: [],
    userSubscription: [],
    isAdmin: {
        type: Boolean,
        default() {
            return false
        }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    formatDate(dateString) {
        if (this.userSubscription.subscription == 'premium' || this.userSubscription.subscription == 'year') {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
        } else {
            return dateString;
        }
    }
  },
  mounted() {
      // console.log(JSON.stringify(this.userData.uid));
  },
}
</script>
